export default {"src":"/_next/static/media/crayfish.68fba612.svg","height":681,"width":681,"blurWidth":0,"blurHeight":0};